// BBQ Assador — featured dishes (real photos only)
// Add new dishes here as they come in. Component handles 4+ items gracefully.

export const BBQ_DISHES = [
  {
    slug: "caracois",
    name: "Caracóis",
    desc: "Petiscos para partilhar — porções generosas, mesa que une.",
    price: "5,50",
    img: "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/1sghom6s_IMG_1077.jpeg",
  },
  {
    slug: "bacalhau-lagareiro",
    name: "Bacalhau à Lagareiro",
    desc: "Assado no ponto, com azeite, alho e tradição.",
    price: "17,90",
    img: "/dishes/lagareiro.jpg",
  },
  {
    slug: "choco-frito",
    name: "Choco Frito",
    desc: "Crosta perfeita, sabor do mar e limão a acompanhar.",
    price: "14,90",
    img: "/dishes/choco.jpg",
  },
  {
    slug: "fondue",
    name: "Fondue",
    desc: "Partilha à mesa, quente e cheio de sabor.",
    img: "/dishes/fondue.jpg",
  },
  {
    slug: "francesinha",
    name: "Francesinha",
    desc: "Intensa, generosa e feita para quem tem apetite a sério.",
    img: "/dishes/francesinha.jpg",
  },
];
